import * as React from "react";
import { Box } from "@mui/material"

import CommonFiltersDateRangeSelected from "./RangeSelected";
import CommonFiltersDateRange from "./DateRange";

export default function CommonFiltersDateRangeBlock({...props}) {
    return <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', mb: -1}}>
            <CommonFiltersDateRangeSelected />
            <CommonFiltersDateRange {...props?.dateRangeProps} />
        </Box>
    </Box>
}